import { render, staticRenderFns } from "./NotificationsPreview.vue?vue&type=template&id=3ffbb6b8&scoped=true"
import script from "./NotificationsPreview.vue?vue&type=script&lang=js"
export * from "./NotificationsPreview.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPreview.vue?vue&type=style&index=0&id=3ffbb6b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffbb6b8",
  null
  
)

export default component.exports